import React from 'react';
import { StyledDrawer, StyledNavigationDrawerList, StyledNavigationDrawerSection } from './navigation-drawer.styles';
import { useNavigation } from '@/navigation/navigation.provider';
import { PrimaryDrawerRouteList } from './partials/primary';
export const NavigationDrawer = ({ onItemClick }) => {
    const { isDrawerOpen } = useNavigation();
    return (<StyledNavigationDrawerSection id="drawer--navigation">
      <StyledDrawer id="drawer__desktop" className={isDrawerOpen ? 'expanded' : 'collapsed'} variant="permanent" transitionDuration={500}>
        <StyledNavigationDrawerList>
          <PrimaryDrawerRouteList onItemClick={onItemClick}/>
        </StyledNavigationDrawerList>
      </StyledDrawer>
    </StyledNavigationDrawerSection>);
};
